var map = {
	"./EULA-candidate.en.2020-10-21.md": 936,
	"./EULA-candidate.en.2022-02-01.md": 937,
	"./EULA-candidate.en.2023-12-06.md": 938,
	"./EULA-candidate.en.2025-09-08.md": 939,
	"./EULA-candidate.nb.2020-10-21.md": 940,
	"./EULA-candidate.nb.2022-02-01.md": 941,
	"./EULA-candidate.nb.2023-12-06.md": 942,
	"./EULA-candidate.nb.2025-09-08.md": 943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;